import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatExpansionModule } from '@angular/material/expansion';
import { NasModelModule } from '@sama/ng-app-state';
import { SharedModule } from '../../shared/shared.module';
import { H3mlModule } from '../h3ml/h3ml.module';
import { LoginWorkspaceHostComponent } from './login-workspace-host.component';
import { LoginWorkspaceComponent } from './login-workspace.component';

@NgModule({
  imports: [
    CommonModule,
    H3mlModule,
    MatExpansionModule,
    NasModelModule,
    SharedModule,
  ],
  declarations: [LoginWorkspaceComponent, LoginWorkspaceHostComponent],
  exports: [LoginWorkspaceComponent, LoginWorkspaceHostComponent],
})
export class LoginWorkspaceModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    customElements.define(
      'ursa-login-workspace',
      createCustomElement(LoginWorkspaceHostComponent, {
        injector: this.injector,
      }),
    );
  }
}
